import HeroSection2 from '../Components/HeroSection2/index2'
import Footer from '../Components/Footer/Footer'
import Card from '../Components/Card_catering/Card'
import ScrollToTop from '../Components/ScrollToTop'

const Catering = () => {
  return (
    <>
      <ScrollToTop />
      <HeroSection2 />
      <Card />
      <Footer />
    </>
  )
}

export default Catering